// Clevertap stuff
import ClevertapReact from './clevertap'
import { isEmpty, getCookie } from "utils/index";
const CLEVERTAP_KEY = 'W8R-KK8-W74Z' || null
export const isMobile = () => {
    let condition = false;
    return window.innerWidth < 768 ? !condition : condition

}
class Clevertap {
    constructor() {
        this.enabled = false
        if (CLEVERTAP_KEY) {
            this.enabled = true
            ClevertapReact.initialize(CLEVERTAP_KEY)
        }
    }

    event = (name, payload = {}) => {
        try {
            let abKey = isMobile() ? 'ct-pwa' : 'ct-ab'
            const ctAb = isEmpty(getCookie(abKey)) ? {} : JSON.parse(decodeURIComponent(getCookie(abKey)))
            if (this.enabled) {
                payload.platform = isMobile() ? "PWA" : "Desktop";
                payload.homeExp_abcookie = ctAb['e_home']
                setTimeout(() => {
                    ClevertapReact.event(name, payload)
                }, 300)
            }
        } catch (e) {
            console.error(e)
        }
    }
}

const ClevertapObject = new Clevertap()
export default ClevertapObject
